<template>
    <a-card
        :bordered="false" 
        class="header-solid h-full" 
        style="background-color: #fff;"
    >
        <template #title>
            <div style="display:flex; flex-direction: row;">   
                <a-avatar
                    :size="64"
                    shape="square"
                    src="/images/company-default.png"
                />
                    
                <div class="mt-10  ml-10">
                    <h6 class="font-semibold mb-15">{{ $t('form-label.alter-project')}} : {{ workHistoryData.project }}</h6>
                    <p class="mb-5" style="font-weight: 600;"> {{ type }} </p>
                    <p class="mb-5" style="font-weight: 600;">{{ $t('form-label.project-start-date')}} :  {{ workHistoryData.startDate }} </p>
                    <p class="mb-5" style="font-weight: 600;">{{ $t('form-label.project-end-date')}} :  {{ workHistoryData.endDate }} </p>
                    <p class="mb-5" style="font-weight: 600;">{{ $t('form-label.performance rating')}} : <a-rate :value="ratingValue" allow-half /> ({{ratingValue}}) </p>
                    <p class="mb-5" style="font-weight: 600;">{{ $t('form-label.note')}} :  {{ workHistoryData.note }} </p>
                </div>
            </div>
        </template>
    </a-card>
</template>

<script>
export default {
    name: "WorkHistoryItem",
    props:{
        workHistoryData:{
            type: Object,
            required: true
        }
    },
    computed:{
        type(){
            if (this.workHistoryData && this.workHistoryData.type == "ARCHITECT"){
                return this.$t('radio-btn-caption.architect');
            } else if (this.workHistoryData && this.workHistoryData.type == "ENGINEER"){
                return this.$t('radio-btn-caption.engineer');
            } else if (this.workHistoryData && this.workHistoryData.type == "PLANNER"){
                return this.$t('radio-btn-caption.planner');
            }
            return ""
        },
        ratingValue(){
            if (this.workHistoryData && this.workHistoryData.rating) {
                return this.workHistoryData.rating;
            }
            return 0;
        },
    }
}
</script>

<style>

</style>